import React, { useEffect, useState } from "react";
import { Box, Button, Drawer, Typography, IconButton } from "@mui/material";
import InputField from "../../../Components/Masters/InputField";
import CloseIcon from "@mui/icons-material/Close";
import MonthYearPicker, { convertMonth } from "./MonthYearPicker";
import CollapsibleSection from "./CollapsibleSection";
import ViewTable from "./ViewTable";
import ViewDate from "../../../Components/Masters/ViewDate";
import CustomTextField from "./CustomField";
import EditIcon from "@mui/icons-material/Edit";
import { getMonthName } from "../../../utils/getMonthName";

const ViewData = ({
  title,
  inputData,
  element,
  viewData,
  setViewData,
  handleEdit,
  setData,
}) => {
  const [expanded, setExpanded] = useState({});

  console.log(element,"element")

  const handleExpand = (section) => {
    setExpanded((prev) => ({ ...prev, [section]: !prev[section] }));
  };
  const [selectedMonth, setSelectedMonth] = useState(""); // Stores the selected month
  const [selectedYear, setSelectedYear] = useState(""); // Stores the selected year
  const rowsInitialState = {
    waterWithdrawal: element?.totalWaterWithdrawal,
    waterDischarge: element?.totalWaterDischarge,
    wastewaterTreatment: element?.totalWastewaterTreatment,
    waterRecycling: element?.totalWaterRecycledAndReused,
  };

  const [rows, setRows] = useState(rowsInitialState);

  useEffect(() => {
    console.log("view1", inputData, element);
    if (element) {
      setFormData(element);
      setRows(rowsInitialState);
      setSelectedMonth(element?.monthYear?.month);
      setSelectedYear(element?.monthYear?.year);
    }
  }, [element]);

  const [formData, setFormData] = useState([]);

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        maxWidth: "100%",
        minHeight: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "25px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "1.6rem",
        }}
      >
        <IconButton
          onClick={() => {
            setViewData(false);
            setData({});
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          width: "720px",
          maxWidth: "100%",
          p: 4,
          backgroundColor: "#fff",
          height: "auto",
          minHeight: "100%",
          overflowY: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",
            mb: 2,
          }}
        >
          Water Data Collection Details
        </Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          1. Consumption Month:
        </Typography>
        <Box
          sx={{ display: "flex", gap: 2, my: 1, mb: "2rem", height: "30px" }}
        >
          <CustomTextField
            value={getMonthName(selectedMonth)}
            disabled={true}
          />
          <CustomTextField value={selectedYear} disabled={true} />
        </Box>
        {inputData.map((section, idx) => (
          <Box sx={{ borderBottom: "1px solid #DBDBDB" }}>
            <CollapsibleSection
              title={`${
                rows[section?.fieldName]
                  ? `${section.title}: ${rows[section?.fieldName]} KL`
                  : section?.fieldName === "interactionWithWater"
                  ? section?.title
                  : `${section.title}: 0 KL`
              }`}
              idx={idx + 1}
              field={rows[section.fieldName]}
              expanded={expanded[section.fieldName]}
              onToggle={() => handleExpand(section.fieldName)}
            >
              {section.fieldName === "interactionWithWater" && (
                <Box sx={{ mb: 1 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    A. Engagement with Water Resources:<br></br>
                    How does the organization engage with water resources in
                    community?
                  </Typography>
                  <CustomTextField
                    width="100%"
                    disabled={true}
                    value={
                      formData.interactionWithWater
                        ?.engagementWithWaterResources
                    }
                    placeholder="N/A"
                  />
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    B. Water Withdrawl Locations:<br></br>
                    Where does the organization withdraw water from
                    (e.g.,rivers, lakes, aquifers)? Provide specific locations &
                    quantities.
                  </Typography>
                  {/* <InputField title="Where does the organization withdraw water from (e.g.,rivers, lakes, aquifers)? Provide specific locations & quantities." /> */}
                </Box>
              )}
              <ViewTable
                fieldName={`${
                  rows[section?.fieldName]
                    ? rows[section?.fieldName]
                    : section?.fieldName
                }`}
                fields={
                  section.fieldName === "interactionWithWater"
                    ? section?.waterWithdrawalLocations?.fields
                    : section?.fields
                }
                data={element}
                // handleClose={() => setViewData(false)}
                rows={
                  section.fieldName === "interactionWithWater"
                    ? formData?.interactionWithWater?.waterWithdrawalLocations
                    : formData?.[section?.fieldName] || []
                }
              />
              {section.fieldName === "interactionWithWater" && (
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    C. Water-Related Impacts:<br></br>
                    Describe any significant water-related impacts your
                    organization has observed or is addressing.
                  </Typography>
                  <CustomTextField
                    disabled={true}
                    width="100%"
                    fieldName={"waterRelatedImpacts"}
                    value={formData.interactionWithWater?.waterRelatedImpacts}
                    placeholder="N/A"
                  />
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    D Water Risk Management:<br></br>
                    What measures are in place to manage water-related risks?
                  </Typography>
                  <CustomTextField
                    width={"100%"}
                    disabled={true}
                    fieldName={"waterRiskManagement"}
                    placeholder="N/A"
                    value={formData.interactionWithWater?.waterRiskManagement}
                  />
                </Box>
              )}
            </CollapsibleSection>
          </Box>
        ))}
        <Button
          variant="contained"
          onClick={handleEdit}
          sx={{
            mt: 3,
            width: "15%",
            textTransform: "none",
            backgroundColor: "#488257",
          }}
        >
          Edit
          {/* {" "} <EditIcon sx={{ marginLeft: "8px", fontSize: "medium" }} /> */}
        </Button>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        height: "100vh",
        minHeight: "100vh",
        overflowY: "auto",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100%",
          minHeight: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={viewData}
      onClose={() => {
        setViewData(false);
        setData({});
      }}
    >
      {list()}
    </Drawer>
  );
};

export default ViewData;
